import styles from "./SiteHeader.module.css";

export function SiteHeader() {
  return (
    <header className={styles.header}>
      <div className={`container ${styles.inner}`}>
        <a href="/" className={styles.brand}>
          <span className={styles.mark} aria-hidden="true">
            ◉
          </span>
          <span>
            Best Pottery Studios <strong>NYC</strong>
          </span>
        </a>
        <nav aria-label="Primary">
          <ul className={styles.nav}>
            <li>
              <a href="#rankings">Rankings</a>
            </li>
            <li>
              <a href="#criteria">Criteria</a>
            </li>
            <li>
              <a href="#rankings" className={styles.cta}>
                View rankings
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
